export const actions = {
  VENTAS_LOAD_REQUESTED: 'VENTAS_LOAD_REQUESTED',
  VENTAS_LOAD_SUCCEEDED: 'VENTAS_LOAD_SUCCEEDED',
  VENTAS_LOAD_FILED: 'VENTAS_LOAD_FILED',

  VENTAS_FILTER_LOAD_REQUESTED: 'VENTAS_FILTER_LOAD_REQUESTED',
  VENTAS_FILTER_LOAD_SUCCEEDED: 'VENTAS_FILTER_LOAD_SUCCEEDED',
  VENTAS_FILTER_LOAD_FILED: 'VENTAS_FILTER_LOAD_FILED',

  VENTAS_CLEAR: 'VENTAS_CLEAR',

  VENTAS_FILTER_MENSAJEROS_NUESTROS_LOAD_REQUESTED:
    'VENTAS_FILTER_MENSAJEROS_NUESTROS_LOAD_REQUESTED',
  VENTAS_FILTER_MENSAJEROS_NUESTROS_LOAD_SUCCEEDED:
    'VENTAS_FILTER_MENSAJEROS_NUESTROS_LOAD_SUCCEEDED',
  VENTAS_FILTER_MENSAJEROS_NUESTROS_LOAD_FILED: 'VENTAS_FILTER_MENSAJEROS_NUESTROS_LOAD_FILED',

  VENTAS_FILTER_GRABADOS_SIN_PERSO_LOAD_REQUESTED:
    'VENTAS_FILTER_GRABADOS_SIN_PERSO_LOAD_REQUESTED',
  VENTAS_FILTER_GRABADOS_SIN_PERSO_LOAD_SUCCEEDED:
    'VENTAS_FILTER_GRABADOS_SIN_PERSO_LOAD_SUCCEEDED',
  VENTAS_FILTER_GRABADOS_SIN_PERSO_LOAD_FAILED: 'VENTAS_FILTER_GRABADOS_SIN_PERSO_LOAD_FAILED',

  VENTAS_FILTER_BORDADOS_SIN_PERSO_LOAD_REQUESTED:
    'VENTAS_FILTER_BORDADOS_SIN_PERSO_LOAD_REQUESTED',
  VENTAS_FILTER_BORDADOS_SIN_PERSO_LOAD_SUCCEEDED:
    'VENTAS_FILTER_BORDADOS_SIN_PERSO_LOAD_SUCCEEDED',
  VENTAS_FILTER_BORDADOS_SIN_PERSO_LOAD_FAILED: 'VENTAS_FILTER_BORDADOS_SIN_PERSO_LOAD_FAILED',

  VENTAS_FILTER_RESCATE_LOAD_REQUESTED: 'VENTAS_FILTER_RESCATE_LOAD_REQUESTED',
  VENTAS_FILTER_RESCATE_LOAD_SUCCEEDED: 'VENTAS_FILTER_RESCATE_LOAD_SUCCEEDED',
  VENTAS_FILTER_RESCATE_LOAD_FILED: 'VENTAS_FILTER_RESCATE_LOAD_FILED',

  VENTAS_FILTER_PERSONALIZADOS_LOAD_REQUESTED: 'VENTAS_FILTER_PERSONALIZADOS_LOAD_REQUESTED',
  VENTAS_FILTER_PERSONALIZADOS_LOAD_SUCCEEDED: 'VENTAS_FILTER_PERSONALIZADOS_LOAD_SUCCEEDED',
  VENTAS_FILTER_PERSONALIZADOS_LOAD_FILED: 'VENTAS_FILTER_PERSONALIZADOS_LOAD_FILED',

  VENTAS_FILTER_PERSONALIZADOS_TOTAL_LOAD_REQUESTED:
    'VENTAS_FILTER_PERSONALIZADOS_TOTAL_LOAD_REQUESTED',
  VENTAS_FILTER_PERSONALIZADOS_TOTAL_LOAD_SUCCEEDED:
    'VENTAS_FILTER_PERSONALIZADOS_TOTAL_LOAD_SUCCEEDED',
  VENTAS_FILTER_PERSONALIZADOS_TOTAL_LOAD_FILED: 'VENTAS_FILTER_PERSONALIZADOS_TOTAL_LOAD_FILED',

  VENTAS_FILTER_PERSONALIZADOS_PREPARADOS_LOAD_REQUESTED:
    'VENTAS_FILTER_PERSONALIZADOS_PREPARADOS_LOAD_REQUESTED',
  VENTAS_FILTER_PERSONALIZADOS_PREPARADOS_LOAD_SUCCEEDED:
    'VENTAS_FILTER_PERSONALIZADOS_PREPARADOS_LOAD_SUCCEEDED',
  VENTAS_FILTER_PERSONALIZADOS_PREPARADOS_LOAD_FILED:
    'VENTAS_FILTER_PERSONALIZADOS_PREPARADOS_LOAD_FILED',

  VENTAS_FILTER_PERSONALIZADOS_FABRICADOS_LOAD_REQUESTED:
    'VENTAS_FILTER_PERSONALIZADOS_FABRICADOS_LOAD_REQUESTED',
  VENTAS_FILTER_PERSONALIZADOS_FABRICADOS_LOAD_SUCCEEDED:
    'VENTAS_FILTER_PERSONALIZADOS_FABRICADOS_LOAD_SUCCEEDED',
  VENTAS_FILTER_PERSONALIZADOS_FABRICADOS_LOAD_FAILED:
    'VENTAS_FILTER_PERSONALIZADOS_FABRICADOS_LOAD_FAILED',

  VENTAS_FILTER_EN_SOBRE_LOAD_REQUESTED: 'VENTAS_FILTER_EN_SOBRE_LOAD_REQUESTED',
  VENTAS_FILTER_EN_SOBRE_LOAD_SUCCEEDED: 'VENTAS_FILTER_EN_SOBRE_LOAD_SUCCEEDED',
  VENTAS_FILTER_EN_SOBRE_LOAD_FILED: 'VENTAS_FILTER_EN_SOBRE_LOAD_FILED',

  VENTAS_FILTER_TODOS_LOAD_REQUESTED: 'VENTAS_FILTER_TODOS_LOAD_REQUESTED',
  VENTAS_FILTER_TODOS_LOAD_SUCCEEDED: 'VENTAS_FILTER_TODOS_LOAD_SUCCEEDED',
  VENTAS_FILTER_TODOS_LOAD_FAILED: 'VENTAS_FILTER_TODOS_LOAD_FAILED',

  VENTAS_FILTER_NOCTURNOS_LOAD_REQUESTED: 'VENTAS_FILTER_NOCTURNOS_LOAD_REQUESTED',
  VENTAS_FILTER_NOCTURNOS_LOAD_SUCCEEDED: 'VENTAS_FILTER_NOCTURNOS_LOAD_SUCCEEDED',
  VENTAS_FILTER_NOCTURNOS_LOAD_FILED: 'VENTAS_FILTER_NOCTURNOS_LOAD_FILED',

  VENTAS_FILTER_FIGURAS_LEGO_LOAD_REQUESTED: 'VENTAS_FILTER_FIGURAS_LEGO_LOAD_REQUESTED',
  VENTAS_FILTER_FIGURAS_LEGO_LOAD_SUCCEEDED: 'VENTAS_FILTER_FIGURAS_LEGO_LOAD_SUCCEEDED',
  VENTAS_FILTER_FIGURAS_LEGO_LOAD_FAILED: 'VENTAS_FILTER_FIGURAS_LEGO_LOAD_FAILED',

  VENTAS_FILTER_NOCTURNOS_CORREOS_LOAD_REQUESTED: 'VENTAS_FILTER_NOCTURNOS_CORREOS_LOAD_REQUESTED',
  VENTAS_FILTER_NOCTURNOS_CORREOS_LOAD_SUCCEEDED: 'VENTAS_FILTER_NOCTURNOS_CORREOS_LOAD_SUCCEEDED',
  VENTAS_FILTER_NOCTURNOS_CORREOS_LOAD_FAILED: 'VENTAS_FILTER_NOCTURNOS_CORREOS_LOAD_FAILED',

  VENTAS_FILTER_DIURNOS_LOAD_REQUESTED: 'VENTAS_FILTER_DIURNOS_LOAD_REQUESTED',
  VENTAS_FILTER_DIURNOS_LOAD_SUCCEEDED: 'VENTAS_FILTER_DIURNOS_LOAD_SUCCEEDED',
  VENTAS_FILTER_DIURNOS_LOAD_FILED: 'VENTAS_FILTER_DIURNOS_LOAD_FILED',

  VENTAS_FILTER_ECOMMERCE_LOAD_REQUESTED: 'VENTAS_FILTER_ECOMMERCE_LOAD_REQUESTED',
  VENTAS_FILTER_ECOMMERCE_LOAD_SUCCEEDED: 'VENTAS_FILTER_ECOMMERCE_LOAD_SUCCEEDED',
  VENTAS_FILTER_ECOMMERCE_LOAD_FILED: 'VENTAS_FILTER_ECOMMERCE_LOAD_FILED',

  VENTAS_FILTER_ECOMMERCE_TRAMO_HORARIO_LOAD_REQUESTED:
    'VENTAS_FILTER_ECOMMERCE_TRAMO_HORARIO_LOAD_REQUESTED',
  VENTAS_FILTER_ECOMMERCE_TRAMO_HORARIO_LOAD_SUCCEEDED:
    'VENTAS_FILTER_ECOMMERCE_TRAMO_HORARIO_LOAD_SUCCEEDED',
  VENTAS_FILTER_ECOMMERCE_TRAMO_HORARIO_LOAD_FILED:
    'VENTAS_FILTER_ECOMMERCE_TRAMO_HORARIO_LOAD_FILED',

  VENTAS_FILTER_LOCAL_LOAD_REQUESTED: 'VENTAS_FILTER_LOCAL_LOAD_REQUESTED',
  VENTAS_FILTER_LOCAL_LOAD_SUCCEEDED: 'VENTAS_FILTER_LOCAL_LOAD_SUCCEEDED',
  VENTAS_FILTER_LOCAL_LOAD_FILED: 'VENTAS_FILTER_LOCAL_LOAD_FILED',

  VENTAS_FILTER_DIGITAL_LOAD_REQUESTED: 'VENTAS_FILTER_DIGITAL_LOAD_REQUESTED',
  VENTAS_FILTER_DIGITAL_LOAD_SUCCEEDED: 'VENTAS_FILTER_DIGITAL_LOAD_SUCCEEDED',
  VENTAS_FILTER_DIGITAL_LOAD_FILED: 'VENTAS_FILTER_DIGITAL_LOAD_FILED',

  VENTAS_FILTER_EMPLEADOS_LOAD_REQUESTED: 'VENTAS_FILTER_EMPLEADOS_LOAD_REQUESTED',
  VENTAS_FILTER_EMPLEADOS_LOAD_SUCCEEDED: 'VENTAS_FILTER_EMPLEADOS_LOAD_SUCCEEDED',
  VENTAS_FILTER_EMPLEADOS_LOAD_FILED: 'VENTAS_FILTER_EMPLEADOS_LOAD_FILED',


  VENTAS_FILTER_EKOMI_LOAD_REQUESTED: 'VENTAS_FILTER_EKOMI_LOAD_REQUESTED',
  VENTAS_FILTER_EKOMI_LOAD_SUCCEEDED: 'VENTAS_FILTER_EKOMI_LOAD_SUCCEEDED',
  VENTAS_FILTER_EKOMI_LOAD_FILED: 'VENTAS_FILTER_EKOMI_LOAD_FILED',

  VENTAS_FILTER_AMAZON_LOAD_REQUESTED: 'VENTAS_FILTER_AMAZON_LOAD_REQUESTED',
  VENTAS_FILTER_AMAZON_LOAD_SUCCEEDED: 'VENTAS_FILTER_AMAZON_LOAD_SUCCEEDED',
  VENTAS_FILTER_AMAZON_LOAD_FAILED: 'VENTAS_FILTER_AMAZON_LOAD_FAILED',

  VENTAS_FILTER_FUERA_DE_ESPANA_LOAD_REQUESTED: 'VENTAS_FILTER_FUERA_DE_ESPANA_LOAD_REQUESTED',
  VENTAS_FILTER_FUERA_DE_ESPANA_LOAD_SUCCEEDED: 'VENTAS_FILTER_FUERA_DE_ESPANA_LOAD_SUCCEEDED',
  VENTAS_FILTER_FUERA_DE_ESPANA_LOAD_FILED: 'VENTAS_FILTER_FUERA_DE_ESPANA_LOAD_FILED',

  VENTAS_FILTER_FUERA_DE_ESPANA_SEUR_LOAD_REQUESTED:
    'VENTAS_FILTER_FUERA_DE_ESPANA_SEUR_LOAD_REQUESTED',
  VENTAS_FILTER_FUERA_DE_ESPANA_SEUR_LOAD_SUCCEEDED:
    'VENTAS_FILTER_FUERA_DE_ESPANA_SEUR_LOAD_SUCCEEDED',
  VENTAS_FILTER_FUERA_DE_ESPANA_SEUR_LOAD_FILED: 'VENTAS_FILTER_FUERA_DE_ESPANA_SEUR_LOAD_FILED',

  VENTAS_FILTER_FUERA_DE_ESPANA_DHL_LOAD_REQUESTED:
    'VENTAS_FILTER_FUERA_DE_ESPANA_DHL_LOAD_REQUESTED',
  VENTAS_FILTER_FUERA_DE_ESPANA_DHL_LOAD_SUCCEEDED:
    'VENTAS_FILTER_FUERA_DE_ESPANA_DHL_LOAD_SUCCEEDED',
  VENTAS_FILTER_FUERA_DE_ESPANA_DHL_LOAD_FILED: 'VENTAS_FILTER_FUERA_DE_ESPANA_DHL_LOAD_FILED',

  VENTAS_FILTER_DHL_LOAD_REQUESTED: 'VENTAS_FILTER_DHL_LOAD_REQUESTED',
  VENTAS_FILTER_DHL_LOAD_SUCCEEDED: 'VENTAS_FILTER_DHL_LOAD_SUCCEEDED',
  VENTAS_FILTER_DHL_LOAD_FILED: 'VENTAS_FILTER_DHL_LOAD_FILED',

  VENTAS_FILTER_NUESTROS_NOCTURNO_LOAD_REQUESTED: 'VENTAS_FILTER_NUESTROS_NOCTURNO_LOAD_REQUESTED',
  VENTAS_FILTER_NUESTROS_NOCTURNO_LOAD_SUCCEEDED: 'VENTAS_FILTER_NUESTROS_NOCTURNO_LOAD_SUCCEEDED',
  VENTAS_FILTER_NUESTROS_NOCTURNO_LOAD_FAILED: 'VENTAS_FILTER_NUESTROS_NOCTURNO_LOAD_FAILED',

  VENTAS_FILTER_CHOCOMENSAJE_MASIVO_LOAD_REQUESTED:
    'VENTAS_FILTER_CHOCOMENSAJE_MASIVO_LOAD_REQUESTED',
  VENTAS_FILTER_CHOCOMENSAJE_MASIVO_LOAD_SUCCEEDED:
    'VENTAS_FILTER_CHOCOMENSAJE_MASIVO_LOAD_SUCCEEDED',
  VENTAS_FILTER_CHOCOMENSAJE_MASIVO_LOAD_FAILED: 'VENTAS_FILTER_CHOCOMENSAJE_MASIVO_LOAD_FAILED',

  VENTA_BYID_LOAD_REQUESTED: 'VENTA_BYID_LOAD_REQUESTED',
  VENTA_BYID_LOAD_SUCCEEDED: 'VENTA_BYID_LOAD_SUCCEEDED',
  VENTA_BYID_LOAD_FILED: 'VENTA_BYID_LOAD_FILED',

  VENTA_BYID_CONTROLDISENO_LOAD_REQUESTED: 'VENTA_BYID_CONTROLDISENO_LOAD_REQUESTED',
  VENTA_BYID_CONTROLDISENO_LOAD_SUCCEEDED: 'VENTA_BYID_CONTROLDISENO_LOAD_SUCCEEDED',
  VENTA_BYID_CONTROLDISENO_LOAD_FILED: 'VENTA_BYID_CONTROLDISENO_LOAD_FILED',

  ADD_VENTA_LOAD_REQUESTED: 'ADD_VENTA_LOAD_REQUESTED',
  ADD_VENTA_LOAD_SUCCEEDED: 'ADD_VENTA_LOAD_SUCCEEDED',
  ADD_VENTA_LOAD_FILED: 'ADD_VENTA_LOAD_FILED',

  RESET_VENTA_LOAD_REQUESTED: 'RESET_VENTA_LOAD_REQUESTED',
  RESET_VENTA_LOAD_SUCCEEDED: 'RESET_VENTA_LOAD_SUCCEEDED',
  RESET_VENTA_LOAD_FILED: 'RESET_VENTA_LOAD_FILED',

  OBSERVACIONES_VENTA_LOAD_REQUESTED: 'OBSERVACIONES_VENTA_LOAD_REQUESTED',
  OBSERVACIONES_VENTA_LOAD_SUCCEEDED: 'OBSERVACIONES_VENTA_LOAD_SUCCEEDED',
  OBSERVACIONES_VENTA_LOAD_FILED: 'OBSERVACIONES_VENTA_LOAD_FILED',

  SET_OBSERVACIONES_BULTO_REQUESTED: 'SET_OBSERVACIONES_BULTO_REQUESTED',
  SET_OBSERVACIONES_BULTO_SUCCEEDED: 'SET_OBSERVACIONES_BULTO_SUCCEEDED',
  SET_OBSERVACIONES_BULTO_FILED: 'SET_OBSERVACIONES_BULTO_FILED',

  SET_OBSERVACIONES_BULTO_LISTA_REQUESTED: 'SET_OBSERVACIONES_BULTO_LISTA_REQUESTED',
  SET_OBSERVACIONES_BULTO_LISTA_SUCCEEDED: 'SET_OBSERVACIONES_BULTO_LISTA_SUCCEEDED',
  SET_OBSERVACIONES_BULTO_LISTA_FAILED: 'SET_OBSERVACIONES_BULTO_LISTA_FAILED',

  SET_BULTOS_CHECK_REQUESTED: 'SET_BULTOS_CHECK_REQUESTED',
  SET_BULTOS_CHECK_SUCCEEDED: 'SET_BULTOS_CHECK_SUCCEEDED',
  SET_BULTOS_CHECK_FILED: 'SET_BULTOS_CHECK_FILED',

  MAIL_OBSERVACION_TEMPLATE_VENTA_LOAD_REQUESTED: 'MAIL_OBSERVACION_TEMPLATE_VENTA_LOAD_REQUESTED',
  MAIL_OBSERVACION_TEMPLATE_VENTA_LOAD_SUCCEEDED: 'MAIL_OBSERVACION_TEMPLATE_VENTA_LOAD_SUCCEEDED',
  MAIL_OBSERVACION_TEMPLATE_VENTA_LOAD_FAILED: 'MAIL_OBSERVACION_TEMPLATE_VENTA_LOAD_FAILED',

  MAIL_OBSERVACION_TEMPLATE_INSERT_REQUESTED: 'MAIL_OBSERVACION_TEMPLATE_INSERT_REQUESTED',
  MAIL_OBSERVACION_TEMPLATE_INSERT_SUCCEEDED: 'MAIL_OBSERVACION_TEMPLATE_INSERT_SUCCEEDED',
  MAIL_OBSERVACION_TEMPLATE_INSERT_FAILED: 'MAIL_OBSERVACION_TEMPLATE_INSERT_FAILED',

  MAIL_OBSERVACION_TEMPLATE_UPDATE_REQUESTED: 'MAIL_OBSERVACION_TEMPLATE_UPDATE_REQUESTED',
  MAIL_OBSERVACION_TEMPLATE_UPDATE_SUCCEEDED: 'MAIL_OBSERVACION_TEMPLATE_UPDATE_SUCCEEDED',
  MAIL_OBSERVACION_TEMPLATE_UPDATE_FAILED: 'MAIL_OBSERVACION_TEMPLATE_UPDATE_FAILED',

  DELETE_MAIL_OBSERVACION_TEMPLATE_REQUESTED: 'DELETE_MAIL_OBSERVACION_TEMPLATE_REQUESTED',
  DELETE_MAIL_OBSERVACION_TEMPLATE_SUCCEEDED: 'DELETE_MAIL_OBSERVACION_TEMPLATE_SUCCEEDED',
  DELETE_MAIL_OBSERVACION_TEMPLATE_FAILED: 'DELETE_MAIL_OBSERVACION_TEMPLATE_FAILED',

  VENTA_UPDATE_REQUESTED: 'VENTA_UPDATE_REQUESTED',
  VENTA_UPDATE_SUCCEEDED: 'VENTA_UPDATE_SUCCEEDED',
  VENTA_UPDATE_FILED: 'VENTA_UPDATE_FILED',

  OBSERVACION_SEGUIMIENTO_VENTA_INSERT_REQUESTED: 'OBSERVACION_SEGUIMIENTO_VENTA_INSERT_REQUESTED',
  OBSERVACION_SEGUIMIENTO_VENTA_INSERT_SUCCEEDED: 'OBSERVACION_SEGUIMIENTO_VENTA_INSERT_SUCCEEDED',
  OBSERVACION_SEGUIMIENTO_VENTA_INSERT_FILED: 'OBSERVACION_SEGUIMIENTO_VENTA_INSERT_FILED',

  OBSERVACION_SEGUIMIENTO_PREPARACION_EMERGENTE_VENTA_INSERT_REQUESTED:
    'OBSERVACION_SEGUIMIENTO_PREPARACION_EMERGENTE_VENTA_INSERT_REQUESTED',
  OBSERVACION_SEGUIMIENTO_PREPARACION_EMERGENTE_VENTA_INSERT_SUCCEEDED:
    'OBSERVACION_SEGUIMIENTO_PREPARACION_EMERGENTE_VENTA_INSERT_SUCCEEDED',
  OBSERVACION_SEGUIMIENTO_PREPARACION_EMERGENTE_VENTA_INSERT_FILED:
    'OBSERVACION_SEGUIMIENTO_PREPARACION_EMERGENTE_VENTA_INSERT_FILED',

  ABONO_DELETE_REQUESTED: 'ABONO_DELETE_REQUESTED',
  ABONO_DELETE_SUCCEEDED: 'ABONO_DELETE_SUCCEEDED',
  ABONO_DELETE_FILED: 'ABONO_DELETE_FILED',

  CUPON_DELETE_REQUESTED: 'CUPON_DELETE_REQUESTED',
  CUPON_DELETE_SUCCEEDED: 'CUPON_DELETE_SUCCEEDED',
  CUPON_DELETE_FILED: 'CUPON_DELETE_FILED',

  CUPONES_LOAD_REQUESTED: 'CUPONES_LOAD_REQUESTED',
  CUPONES_LOAD_SUCCEEDED: 'CUPONES_LOAD_SUCCEEDED',
  CUPONES_LOAD_FILED: 'CUPONES_LOAD_FILED',

  ADD_CUPONES_REQUESTED: 'ADD_CUPONES_REQUESTED',
  ADD_CUPONES_SUCCEEDED: 'ADD_CUPONES_SUCCEEDED',
  ADD_CUPONES_FILED: 'ADD_CUPONES_FILED',

  CANCELAR_VENTA_REQUESTED: 'CANCELAR_VENTA_REQUESTED',
  CANCELAR_VENTA_SUCCEEDED: 'CANCELAR_VENTA_SUCCEEDED',
  CANCELAR_VENTA_FILED: 'CANCELAR_VENTA_FILED',

  ENVIAR_MAIL_OBSERVACION_VENTA_REQUESTED: 'ENVIAR_MAIL_OBSERVACION_VENTA_REQUESTED',
  ENVIAR_MAIL_OBSERVACION_VENTA_SUCCEEDED: 'ENVIAR_MAIL_OBSERVACION_VENTA_SUCCEEDED',
  ENVIAR_MAIL_OBSERVACION_VENTA_FILED: 'ENVIAR_MAIL_OBSERVACION_VENTA_FILED',

  ENVIAR_MAIL_OBSERVACION_VENTA_DONE_REQUESTED: 'ENVIAR_MAIL_OBSERVACION_VENTA_DONE_REQUESTED',
  ENVIAR_MAIL_OBSERVACION_VENTA_DONE_SUCCEEDED: 'ENVIAR_MAIL_OBSERVACION_VENTA_DONE_SUCCEEDED',
  ENVIAR_MAIL_OBSERVACION_VENTA_DONE_FILED: 'ENVIAR_MAIL_OBSERVACION_VENTA_DONE_FILED',

  BORRAR_MENSAJERO_REQUESTED: 'BORRAR_MENSAJERO_REQUESTED',
  BORRAR_MENSAJERO_SUCCEEDED: 'BORRAR_MENSAJERO_SUCCEEDED',
  BORRAR_MENSAJERO_FILED: 'BORRAR_MENSAJERO_FILED',

  BORRAR_BANDEJA_REQUESTED: 'BORRAR_BANDEJA_REQUESTED',
  BORRAR_BANDEJA_SUCCEEDED: 'BORRAR_BANDEJA_SUCCEEDED',
  BORRAR_BANDEJA_FILED: 'BORRAR_BANDEJA_FILED',

  MARCAR_PAGADO_REQUESTED: 'MARCAR_PAGADO_REQUESTED',
  MARCAR_PAGADO_SUCCEEDED: 'MARCAR_PAGADO_SUCCEEDED',
  MARCAR_PAGADO_FILED: 'MARCAR_PAGADO_FILED',

  ASIGNAR_NUMERO_FACTURA_SUCCEEDED: 'ASIGNAR_NUMERO_FACTURA_SUCCEEDED',

  INSERTAR_NUEVA_DEVOLUCION_REQUESTED: 'INSERTAR_NUEVA_DEVOLUCION_REQUESTED',
  INSERTAR_NUEVA_DEVOLUCION_SUCCEEDED: 'INSERTAR_NUEVA_DEVOLUCION_SUCCEEDED',
  INSERTAR_NUEVA_DEVOLUCION_FILED: 'INSERTAR_NUEVA_DEVOLUCION_FILED',

  ANULAR_DEVOLUCION_REQUESTED: 'ANULAR_DEVOLUCION_REQUESTED',
  ANULAR_DEVOLUCION_SUCCEEDED: 'ANULAR_DEVOLUCION_SUCCEEDED',
  ANULAR_DEVOLUCION_FILED: 'ANULAR_DEVOLUCION_FILED',

  SET_VENTA_LETRA_REQUESTED: 'SET_VENTA_LETRA_REQUESTED',
  SET_VENTA_LETRA_SUCCEEDED: 'SET_VENTA_LETRA_SUCCEEDED',
  SET_VENTA_LETRA_FILED: 'SET_VENTA_LETRA_FILED',

  SET_VENTA_BANDEJA_REQUESTED: 'SET_VENTA_BANDEJA_REQUESTED',
  SET_VENTA_BANDEJA_SUCCEEDED: 'SET_VENTA_BANDEJA_SUCCEEDED',
  SET_VENTA_BANDEJA_FILED: 'SET_VENTA_BANDEJA_FILED',

  DELETE_VENTA_BANDEJA_REQUESTED: 'DELETE_VENTA_BANDEJA_REQUESTED',
  DELETE_VENTA_BANDEJA_SUCCEEDED: 'DELETE_VENTA_BANDEJA_SUCCEEDED',
  DELETE_VENTA_BANDEJA_FILED: 'DELETE_VENTA_BANDEJA_FILED',

  REMOVE_VENTA_BANDEJA_REQUESTED: 'REMOVE_VENTA_BANDEJA_REQUESTED',
  REMOVE_VENTA_BANDEJA_SUCCEEDED: 'REMOVE_VENTA_BANDEJA_SUCCEEDED',
  REMOVE_VENTA_BANDEJA_FILED: 'REMOVE_VENTA_BANDEJA_FILED',

  REMOVE_VENTA_ESTANTE_REQUESTED: 'REMOVE_VENTA_ESTANTE_REQUESTED',
  REMOVE_VENTA_ESTANTE_SUCCEEDED: 'REMOVE_VENTA_ESTANTE_SUCCEEDED',
  REMOVE_VENTA_ESTANTE_FILED: 'REMOVE_VENTA_ESTANTE_FILED',

  REMOVE_ALL_VENTA_BANDEJA_REQUESTED: 'REMOVE_ALL_VENTA_BANDEJA_REQUESTED',
  REMOVE_ALL_VENTA_BANDEJA_SUCCEEDED: 'REMOVE_ALL_VENTA_BANDEJA_SUCCEEDED',
  REMOVE_ALL_VENTA_BANDEJA_FILED: 'REMOVE_ALL_VENTA_BANDEJA_FILED',

  SET_VENTA_VIP_REQUESTED: 'SET_VENTA_VIP_REQUESTED',
  SET_VENTA_VIP_SUCCEEDED: 'SET_VENTA_VIP_SUCCEEDED',
  SET_VENTA_VIP_FILED: 'SET_VENTA_VIP_FILED',

  INSERT_ABONO_REQUESTED: 'INSERT_ABONO_REQUESTED',
  INSERT_ABONO_SUCCEEDED: 'INSERT_ABONO_SUCCEEDED',
  INSERT_ABONO_FILED: 'INSERT_ABONO_FILED',

  TRASPASAR_VENTA_REQUESTED: 'TRASPASAR_VENTA_REQUESTED',
  TRASPASAR_VENTA_SUCCEEDED: 'TRASPASAR_VENTA_SUCCEEDED',
  TRASPASAR_VENTA_FILED: 'TRASPASAR_VENTA_FILED',

  SET_VENTA_ITEM_FALTANTE: 'SET_VENTA_ITEM_FALTANTE',

  DHL_BUSCAR_REQUESTED: 'DHL_BUSCAR_REQUESTED',
  DHL_BUSCAR_SUCCEEDED: 'DHL_BUSCAR_SUCCEEDED',
  DHL_BUSCAR_FILED: 'DHL_BUSCAR_FILED',

  DHL_DHL_BUSCAR_REQUESTED: 'DHL_DHL_BUSCAR_REQUESTED',
  DHL_DHL_BUSCAR_SUCCEEDED: 'DHL_DHL_BUSCAR_SUCCEEDED',
  DHL_DHL_BUSCAR_FILED: 'DHL_DHL_BUSCAR_FILED',

  MRWCLICK_BUSCAR_REQUESTED: 'MRWCLICK_BUSCAR_REQUESTED',
  MRWCLICK_BUSCAR_SUCCEEDED: 'MRWCLICK_BUSCAR_SUCCEEDED',
  MRWCLICK_BUSCAR_FILED: 'MRWCLICK_BUSCAR_FILED',

  MRWCLICK_DIURNOS_REQUESTED: 'MRWCLICK_DIURNOS_REQUESTED',
  MRWCLICK_DIURNOS_SUCCEEDED: 'MRWCLICK_DIURNOS_SUCCEEDED',
  MRWCLICK_DIURNOS_FILED: 'MRWCLICK_DIURNOS_FILED',

  MRWCLICK_NOCTURNOS_REQUESTED: 'MRWCLICK_NOCTURNOS_REQUESTED',
  MRWCLICK_NOCTURNOS_SUCCEEDED: 'MRWCLICK_NOCTURNOS_SUCCEEDED',
  MRWCLICK_NOCTURNOS_FILED: 'MRWCLICK_NOCTURNOS_FILED',

  MRWCLICK_ECOMMERCE_REQUESTED: 'MRWCLICK_ECOMMERCE_REQUESTED',
  MRWCLICK_ECOMMERCE_SUCCEEDED: 'MRWCLICK_ECOMMERCE_SUCCEEDED',
  MRWCLICK_ECOMMERCE_FILED: 'MRWCLICK_ECOMMERCE_FILED',

  MRWCLICK_ECOMMERCETH_REQUESTED: 'MRWCLICK_ECOMMERCETH_REQUESTED',
  MRWCLICK_ECOMMERCETH_SUCCEEDED: 'MRWCLICK_ECOMMERCETH_SUCCEEDED',
  MRWCLICK_ECOMMERCETH_FILED: 'MRWCLICK_ECOMMERCETH_FILED',

  MRWCLICK_SOBRE_REQUESTED: 'MRWCLICK_SOBRE_REQUESTED',
  MRWCLICK_SOBRE_SUCCEEDED: 'MRWCLICK_SOBRE_SUCCEEDED',
  MRWCLICK_SOBRE_FILED: 'MRWCLICK_SOBRE_FILED',

  SEUR_BUSCAR_REQUESTED: 'SEUR_BUSCAR_REQUESTED',
  SEUR_BUSCAR_SUCCEEDED: 'SEUR_BUSCAR_SUCCEEDED',
  SEUR_BUSCAR_FILED: 'SEUR_BUSCAR_FILED',

  SEUR_SEUR_BUSCAR_REQUESTED: 'SEUR_SEUR_BUSCAR_REQUESTED',
  SEUR_SEUR_BUSCAR_SUCCEEDED: 'SEUR_SEUR_BUSCAR_SUCCEEDED',
  SEUR_SEUR_BUSCAR_FILED: 'SEUR_SEUR_BUSCAR_FILED',

  VENTA_CAMBIAR_ESTADO_MENSAJERIA_REQUESTED: 'VENTA_CAMBIAR_ESTADO_MENSAJERIA_REQUESTED',
  VENTA_CAMBIAR_ESTADO_MENSAJERIA_SUCCEEDED: 'VENTA_CAMBIAR_ESTADO_MENSAJERIA_SUCCEEDED',
  VENTA_CAMBIAR_ESTADO_MENSAJERIA_FILED: 'VENTA_CAMBIAR_ESTADO_MENSAJERIA_FILED',

  VENTA_CAMBIAR_ESTADO_MENSAJERIA_SEUR_REQUESTED: 'VENTA_CAMBIAR_ESTADO_MENSAJERIA_SEUR_REQUESTED',
  VENTA_CAMBIAR_ESTADO_MENSAJERIA_SEUR_SUCCEEDED: 'VENTA_CAMBIAR_ESTADO_MENSAJERIA_SEUR_SUCCEEDED',
  VENTA_CAMBIAR_ESTADO_MENSAJERIA_SEUR_FILED: 'VENTA_CAMBIAR_ESTADO_MENSAJERIA_SEUR_FILED',

  VENTA_CAMBIAR_ESTADO_MENSAJERIA_CORREOS_EXPRESS_REQUESTED:
    'VENTA_CAMBIAR_ESTADO_MENSAJERIA_CORREOS_EXPRESS_REQUESTED',
  VENTA_CAMBIAR_ESTADO_MENSAJERIA_CORREOS_EXPRESS_SUCCEEDED:
    'VENTA_CAMBIAR_ESTADO_MENSAJERIA_CORREOS_EXPRESS_SUCCEEDED',
  VENTA_CAMBIAR_ESTADO_MENSAJERIA_CORREOS_EXPRESS_FILED:
    'VENTA_CAMBIAR_ESTADO_MENSAJERIA_CORREOS_EXPRESS_FILED',

  UPDATE_DHL_OBJETOS: 'UPDATE_DHL_OBJETOS',

  DHLS_UPDATE_REQUESTED: 'DHLS_UPDATE_REQUESTED',
  DHLS_UPDATE_SUCCEEDED: 'DHLS_UPDATE_SUCCEEDED',
  DHLS_UPDATE_FAILED: 'DHLS_UPDATE_FAILED',

  DHLS_TRANSMITIR_REQUESTED: 'DHLS_TRANSMITIR_REQUESTED',
  DHLS_TRANSMITIR_SUCCEEDED: 'DHLS_TRANSMITIR_SUCCEEDED',
  DHLS_TRANSMITIR_FAILED: 'DHLS_TRANSMITIR_FAILED',

  MRWCLICK_TRANSMITIR_REQUESTED: 'MRWCLICK_TRANSMITIR_REQUESTED',
  MRWCLICK_TRANSMITIR_SUCCEEDED: 'MRWCLICK_TRANSMITIR_SUCCEEDED',
  MRWCLICK_TRANSMITIR_FAILED: 'MRWCLICK_TRANSMITIR_FAILED',

  UPDATE_SEUR_OBJETOS: 'UPDATE_SEUR_OBJETOS',

  UPDATE_CORREOS_EXPRESS_OBJETOS: 'UPDATE_CORREOS_EXPRESS_OBJETOS',

  UPDATE_MRWCLICK_OBJETOS: 'UPDATE_MRWCLICK_OBJETOS',

  MRWCLICK_UPDATE_REQUESTED: 'MRWCLICK_UPDATE_REQUESTED',
  MRWCLICK_UPDATE_SUCCEEDED: 'MRWCLICK_UPDATE_SUCCEEDED',
  MRWCLICK_UPDATE_FAILED: 'MRWCLICK_UPDATE_FAILED',

  SEURS_UPDATE_REQUESTED: 'SEURS_UPDATE_REQUESTED',
  SEURS_UPDATE_SUCCEEDED: 'SEURS_UPDATE_SUCCEEDED',
  SEURS_UPDATE_FAILED: 'SEURS_UPDATE_FAILED',

  CORREOS_EXPRESS_UPDATE_REQUESTED: 'CORREOS_EXPRESS_UPDATE_REQUESTED',
  CORREOS_EXPRESS_UPDATE_SUCCEEDED: 'CORREOS_EXPRESS_UPDATE_SUCCEEDED',
  CORREOS_EXPRESS_UPDATE_FAILED: 'CORREOS_EXPRESS_UPDATE_FAILED',

  SEURS_TRANSMITIR_REQUESTED: 'SEURS_TRANSMITIR_REQUESTED',
  SEURS_TRANSMITIR_SUCCEEDED: 'SEURS_TRANSMITIR_SUCCEEDED',
  SEURS_TRANSMITIR_FAILED: 'SEURS_TRANSMITIR_FAILED',

  CORREOS_EXPRESS_TRANSMITIR_REQUESTED: 'CORREOS_EXPRESS_TRANSMITIR_REQUESTED',
  CORREOS_EXPRESS_TRANSMITIR_SUCCEEDED: 'CORREOS_EXPRESS_TRANSMITIR_SUCCEEDED',
  CORREOS_EXPRESS_TRANSMITIR_FAILED: 'CORREOS_EXPRESS_TRANSMITIR_FAILED',

  ADD_LOG_VENTA_ITEM_SEPARADO_REQUESTED: 'ADD_LOG_VENTA_ITEM_SEPARADO_REQUESTED',
  ADD_LOG_VENTA_ITEM_SEPARADO_SUCCEEDED: 'ADD_LOG_VENTA_ITEM_SEPARADO_SUCCEEDED',
  ADD_LOG_VENTA_ITEM_SEPARADO_FAILED: 'ADD_LOG_VENTA_ITEM_SEPARADO_FAILED',

  SET_DISENO_SVG_VENTA_ITEM_DESCARGADO: 'SET_DISENO_SVG_VENTA_ITEM_DESCARGADO',
  DELETE_IMAGEN_FINAL_DISENO_SVG: 'DELETE_IMAGEN_FINAL_DISENO_SVG',

  ADD_LOG_VENTA_ITEM_PERSONALIZADO: 'ADD_LOG_VENTA_ITEM_PERSONALIZADO',
  SET_VENTA_ITEM_IMPRIMIR: 'SET_VENTA_ITEM_IMPRIMIR',
  DELETE_VENTA_ITEMS: 'DELETE_VENTA_ITEMS',
  VENTA_ITEM_MARCAR_ELIMINAR: 'VENTA_ITEM_MARCAR_ELIMINAR',
  VENTA_ITEM_DESMARCAR_ELIMINAR: 'VENTA_ITEM_DESMARCAR_ELIMINAR',
  VENTA_OBSERVACION_PERSONALIZACION_VENTA_INSERTED:
    'VENTA_OBSERVACION_PERSONALIZACION_VENTA_INSERTED',

  VENTA_ITEM_ILUSTRACION_INSERTED: 'VENTA_ITEM_ILUSTRACION_INSERTED',
  VENTA_ITEM_ILUSTRACION_DELETED: 'VENTA_ITEM_ILUSTRACION_DELETED',
  ADD_LOG_MAIL_VENTA: 'ADD_LOG_MAIL_VENTA',
  VENTA_ITEM_AMAZON_ZIP_INSERTED: ' VENTA_ITEM_AMAZON_ZIP_INSERTED',

  VENTA_ITEM_IMAGENES_INCIDENCIA_INSERTED: 'VENTA_ITEM_IMAGENES_INCIDENCIA_INSERTED',
  VENTA_ITEM_IMAGEN_INCIDENCIA_DELETED: 'VENTA_ITEM_IMAGEN_INCIDENCIA_DELETED',

  CORREOS_EXPRESS_BUSCAR_REQUESTED: 'CORREOS_EXPRESS_BUSCAR_REQUESTED',
  CORREOS_EXPRESS_BUSCAR_SUCCEEDED: 'CORREOS_EXPRESS_BUSCAR_SUCCEEDED',
  CORREOS_EXPRESS_BUSCAR_FAILED: 'CORREOS_EXPRESS_BUSCAR_FAILED',

  CORREOS_EXPRESS_ECOMMERCE_REQUESTED: 'CORREOS_EXPRESS_ECOMMERCE_REQUESTED',
  CORREOS_EXPRESS_ECOMMERCE_SUCCEEDED: 'CORREOS_EXPRESS_ECOMMERCE_SUCCEEDED',
  CORREOS_EXPRESS_ECOMMERCE_FAILED: 'CORREOS_EXPRESS_ECOMMERCE_FAILED',

  CORREOS_EXPRESS_ECOMMERCE_TRAMO_REQUESTED: 'CORREOS_EXPRESS_ECOMMERCE_TRAMO_REQUESTED',
  CORREOS_EXPRESS_ECOMMERCE_TRAMO_SUCCEEDED: 'CORREOS_EXPRESS_ECOMMERCE_TRAMO_SUCCEEDED',
  CORREOS_EXPRESS_ECOMMERCE_TRAMO_FAILED: 'CORREOS_EXPRESS_ECOMMERCE_TRAMO_FAILED',

  CORREOS_EXPRESS_SOBRES_REQUESTED: 'CORREOS_EXPRESS_SOBRES_REQUESTED',
  CORREOS_EXPRESS_SOBRES_SUCCEEDED: 'CORREOS_EXPRESS_SOBRES_SUCCEEDED',
  CORREOS_EXPRESS_SOBRES_FAILED: 'CORREOS_EXPRESS_SOBRES_FAILED',

  OBSERVACION_INSERT_REQUESTED: 'OBSERVACION_INSERT_REQUESTED',
  OBSERVACION_INSERT_SUCCEEDED: 'OBSERVACION_INSERT_SUCCEEDED',
  OBSERVACION_INSERT_FILED: 'OBSERVACION_INSERT_FILED',

  OBSERVACION_UPDATE_REQUESTED: 'OBSERVACION_UPDATE_REQUESTED',
  OBSERVACION_UPDATE_SUCCEEDED: 'OBSERVACION_UPDATE_SUCCEEDED',
  OBSERVACION_UPDATE_FILED: 'OBSERVACION_UPDATE_FILED',

  OBSERVACION_DELETE_REQUESTED: 'OBSERVACION_DELETE_REQUESTED',
  OBSERVACION_DELETE_SUCCEEDED: 'OBSERVACION_DELETE_SUCCEEDED',
  OBSERVACION_DELETE_FILED: 'OBSERVACION_DELETE_FILED',

  ESTADOS_BULTOS_LOAD_REQUESTED: 'ESTADOS_BULTOS_LOAD_REQUESTED',
  ESTADOS_BULTOS_LOAD_SUCCEEDED: 'ESTADOS_BULTOS_LOAD_SUCCEEDED',
  ESTADOS_BULTOS_LOAD_FILED: 'ESTADOS_BULTOS_LOAD_FILED',

  ESTADOS_BULTOS_INSERT_REQUESTED: 'ESTADOS_BULTOS_INSERT_REQUESTED',
  ESTADOS_BULTOS_INSERT_SUCCEEDED: 'ESTADOS_BULTOS_INSERT_SUCCEEDED',
  ESTADOS_BULTOS_INSERT_FILED: 'ESTADOS_BULTOS_INSERT_FILED',

  ESTADOS_BULTOS_UPDATE_REQUESTED: 'ESTADOS_BULTOS_UPDATE_REQUESTED',
  ESTADOS_BULTOS_UPDATE_SUCCEEDED: 'ESTADOS_BULTOS_UPDATE_SUCCEEDED',
  ESTADOS_BULTOS_UPDATE_FILED: 'ESTADOS_BULTOS_UPDATE_FILED',

  ESTADOS_BULTOS_DELETE_REQUESTED: 'ESTADOS_BULTOS_DELETE_REQUESTED',
  ESTADOS_BULTOS_DELETE_SUCCEEDED: 'ESTADOS_BULTOS_DELETE_SUCCEEDED',
  ESTADOS_BULTOS_DELETE_FILED: 'ESTADOS_BULTOS_DELETE_FILED',

  TODAS_BANDEJAS_LOAD_REQUESTED: 'TODAS_BANDEJAS_LOAD_REQUESTED',
  TODAS_BANDEJAS_LOAD_SUCCEEDED: 'TODAS_BANDEJAS_LOAD_SUCCEEDED',
  TODAS_BANDEJAS_LOAD_FILED: 'TODAS_BANDEJAS_LOAD_FILED',

  BANDEJA_LOAD_REQUESTED: 'BANDEJA_LOAD_REQUESTED',
  BANDEJA_LOAD_SUCCEEDED: 'BANDEJA_LOAD_SUCCEEDED',
  BANDEJA_LOAD_FILED: 'BANDEJA_LOAD_FILED',

  BANDEJA_TERMINADA_REQUESTED: 'BANDEJA_TERMINADA_REQUESTED',
  BANDEJA_TERMINADA_SUCCEEDED: 'BANDEJA_TERMINADA_SUCCEEDED',
  BANDEJA_TERMINADA_FILED: 'BANDEJA_TERMINADA_LOAD_FILED',

  TODAS_BANDEJAS_VACIAR_REQUESTED: 'TODAS_BANDEJAS_VACIAR_REQUESTED',
  TODAS_BANDEJAS_VACIAR_SUCCEEDED: 'TODAS_BANDEJAS_VACIAR_SUCCEEDED',
  TODAS_BANDEJAS_VACIAR_FILED: 'TODAS_BANDEJAS_VACIAR_FILED',

  BANDEJA_VACIAR_REQUESTED: 'BANDEJA_VACIAR_REQUESTED',
  BANDEJA_VACIAR_SUCCEEDED: 'BANDEJA_VACIAR_SUCCEEDED',
  BANDEJA_VACIAR_FILED: 'BANDEJA_VACIAR_FILED',

  BANDEJAS_LOAD_REQUESTED: 'BANDEJAS_LOAD_REQUESTED',
  BANDEJAS_LOAD_SUCCEEDED: 'BANDEJAS_LOAD_SUCCEEDED',
  BANDEJAS_LOAD_FILED: 'BANDEJAS_LOAD_FILED',

  BANDEJAS_LOG_LOAD_REQUESTED: 'BANDEJAS_LOG_LOAD_REQUESTED',
  BANDEJAS_LOG_LOAD_SUCCEEDED: 'BANDEJAS_LOG_LOAD_SUCCEEDED',
  BANDEJAS_LOG_LOAD_FILED: 'BANDEJAS_LOG_LOAD_FILED',

  BANDEJA_TERMINAR_REQUESTED: 'BANDEJA_TERMINAR_REQUESTED',
  BANDEJA_TERMINAR_SUCCEEDED: 'BANDEJA_TERMINAR_SUCCEEDED',
  BANDEJA_TERMINAR_FILED: 'BANDEJA_TERMINAR_FILED',

  ESTANTERIAS_LOAD_REQUESTED: 'ESTANTERIAS_LOAD_REQUESTED',
  ESTANTERIAS_LOAD_SUCCEEDED: 'ESTANTERIAS_LOAD_SUCCEEDED',
  ESTANTERIAS_LOAD_FILED: 'ESTANTERIAS_LOAD_FILED',

  ESTANTES_LLENOS_LOAD_REQUESTED: 'ESTANTES_LLENOS_LOAD_REQUESTED',
  ESTANTES_LLENOS_LOAD_SUCCEEDED: 'ESTANTES_LLENOS_LOAD_SUCCEEDED',
  ESTANTES_LLENOS_LOAD_FILED: 'ESTANTES_LLENOS_LOAD_FILED',

  ESTANTERIA_UPDATE_REQUESTED: 'ESTANTERIA_UPDATE_REQUESTED',
  ESTANTERIA_UPDATE_SUCCEEDED: 'ESTANTERIA_UPDATE_SUCCEEDED',
  ESTANTERIA_UPDATE_FILED: 'ESTANTERIA_UPDATE_FILED',

  ESTANTERIA_INSERT_REQUESTED: 'ESTANTERIA_INSERT_REQUESTED',
  ESTANTERIA_INSERT_SUCCEEDED: 'ESTANTERIA_INSERT_SUCCEEDED',
  ESTANTERIA_INSERT_FILED: 'ESTANTERIA_INSERT_FILED',

  ESTANTERIA_DELETE_REQUESTED: 'ESTANTERIA_DELETE_REQUESTED',
  ESTANTERIA_DELETE_SUCCEEDED: 'ESTANTERIA_DELETE_SUCCEEDED',
  ESTANTERIA_DELETE_FILED: 'ESTANTERIA_DELETE_FILED',

  SET_VENTA_ESTANTERIA_UPDATE_REQUESTED: 'SET_VENTA_ESTANTERIA_UPDATE_REQUESTED',
  SET_VENTA_ESTANTERIA_UPDATE_SUCCEEDED: 'SET_VENTA_ESTANTERIA_UPDATE_SUCCEEDED',
  SET_VENTA_ESTANTERIA_UPDATE_FAILED: 'SET_VENTA_ESTANTERIA_UPDATE_FAILED',

  CODIGO_BARRAS_ESTANTERIA_LOAD_REQUESTED: 'CODIGO_BARRAS_ESTANTERIA_LOAD_REQUESTED',
  CODIGO_BARRAS_ESTANTERIA_LOAD_SUCCEEDED: 'CODIGO_BARRAS_ESTANTERIA_LOAD_SUCCEEDED',
  CODIGO_BARRAS_ESTANTERIA_LOAD_FILED: 'CODIGO_BARRAS_ESTANTERIA_LOAD_FILED',

  ESTANTE_VENTA_LOAD_REQUESTED: 'ESTANTE_VENTA_LOAD_REQUESTED',
  ESTANTE_VENTA_LOAD_SUCCEEDED: 'ESTANTE_VENTA_LOAD_SUCCEEDED',
  ESTANTE_VENTA_LOAD_FILED: 'ESTANTE_VENTA_LOAD_FILED',

  CORREOS_EXPRESS_LOAD_REQUESTED: 'CORREOS_EXPRESS_LOAD_REQUESTED',
  CORREOS_EXPRESS_LOAD_SUCCEEDED: 'CORREOS_EXPRESS_LOAD_SUCCEEDED',
  CORREOS_EXPRESS_LOAD_FILED: 'CORREOS_EXPRESS_LOAD_FILED',

  ADD_ITEM_VENTA_PERSONALIZADO_REQUESTED: 'ADD_ITEM_VENTA_PERSONALIZADO_REQUESTED',
  ADD_ITEM_VENTA_PERSONALIZADO_SUCCEEDED: 'ADD_ITEM_VENTA_PERSONALIZADO_SUCCEEDED',
  ADD_ITEM_VENTA_PERSONALIZADO_FILED: 'ADD_ITEM_VENTA_PERSONALIZADO_FILED',

  SET_VENTA_FINALIZAR_IMPRIMIR_REQUESTED: 'SET_VENTA_FINALIZAR_IMPRIMIR_REQUESTED',
  SET_VENTA_FINALIZAR_IMPRIMIR_SUCCEEDED: 'SET_VENTA_FINALIZAR_IMPRIMIR_SUCCEEDED',
  SET_VENTA_FINALIZAR_IMPRIMIR_FILED: 'SET_VENTA_FINALIZAR_IMPRIMIR_FILED',

  GET_ORDEN_ESTANTERIA_REQUESTED: 'GET_ORDEN_ESTANTERIA_REQUESTED',
  GET_ORDEN_ESTANTERIA_SUCCEEDED: 'GET_ORDEN_ESTANTERIA_SUCCEEDED',
  GET_ORDEN_ESTANTERIA_FILED: 'GET_ORDEN_ESTANTERIA_FILED',

  SET_ORDEN_ESTANTERIA_REQUESTED: 'SET_ORDEN_ESTANTERIA_REQUESTED',
  SET_ORDEN_ESTANTERIA_SUCCEEDED: 'SET_ORDEN_ESTANTERIA_SUCCEEDED',
  SET_ORDEN_ESTANTERIA_FILED: 'SET_ORDEN_ESTANTERIA_FILED',

  GET_ESTANTE_ALEATORIO_REQUESTED: 'GET_ESTANTE_ALEATORIO_REQUESTED',
  GET_ESTANTE_ALEATORIO_SUCCEEDED: 'GET_ESTANTE_ALEATORIO_SUCCEEDED',
  GET_ESTANTE_ALEATORIO_FILED: 'GET_ESTANTE_ALEATORIO_FILED',

  OBSERVACION_CIERRE_VENTA_INSERT_REQUESTED: 'OBSERVACION_CIERRE_VENTA_INSERT_REQUESTED',
  OBSERVACION_CIERRE_VENTA_INSERT_SUCCEEDED: 'OBSERVACION_CIERRE_VENTA_INSERT_SUCCEEDED',
  OBSERVACION_CIERRE_VENTA_INSERT_FAILED: 'OBSERVACION_CIERRE_VENTA_INSERT_FAILED',

  ADD_ITEM_VENTA_VERIFICADO_REQUESTED: 'ADD_ITEM_VENTA_VERIFICADO_REQUESTED',
  ADD_ITEM_VENTA_VERIFICADO_SUCCEEDED: 'ADD_ITEM_VENTA_VERIFICADO_SUCCEEDED',
  ADD_ITEM_VENTA_VERIFICADO_FAILED: 'ADD_ITEM_VENTA_VERIFICADO_FAILED',

  GET_VENTAS_AGRUPADAS_REQUESTED: 'GET_VENTAS_AGRUPADAS_REQUESTED',
  GET_VENTAS_AGRUPADAS_SUCCEEDED: 'GET_VENTAS_AGRUPADAS_SUCCEEDED',
  GET_VENTAS_AGRUPADAS_FAILED: 'GET_VENTAS_AGRUPADAS_FAILED',

  SET_BANDEJA_PROPUESTA_LOAD_REQUESTED: 'SET_BANDEJA_PROPUESTA_LOAD_REQUESTED',
  SET_BANDEJA_PROPUESTA_LOAD_SUCCEEDED: 'SET_BANDEJA_PROPUESTA__LOAD_SUCCEEDED',
  SET_BANDEJA_PROPUESTA_LOAD_FAILED: 'SET_BANDEJA_PROPUESTA_LOAD_FAILED',

  GET_MODIFICACIONES_VENTA_REQUESTED: 'GET_MODIFICACIONES_VENTA_REQUESTED',
  GET_MODIFICACIONES_VENTA_SUCCEEDED: 'GET_MODIFICACIONES_VENTA_SUCCEEDED',
  GET_MODIFICACIONES_VENTA_FAILED: 'GET_MODIFICACIONES_VENTA_FAILED',

  SET_ESTADO_VENTA_REQUESTED: 'SET_ESTADO_VENTA_REQUESTED',
  SET_ESTADO_VENTA_SUCCEEDED: 'SET_ESTADO_VENTA_SUCCEEDED',
  SET_ESTADO_VENTA_FAILED: 'SET_ESTADO_VENTA_FAILED',

  SET_ESTADO_BULTO_VENTA_REQUESTED: 'SET_ESTADO_BULTO_VENTA_REQUESTED',
  SET_ESTADO_BULTO_VENTA_SUCCEEDED: 'SET_ESTADO_BULTO_VENTA_SUCCEEDED',
  SET_ESTADO_BULTO_VENTA_FAILED: 'SET_ESTADO_BULTO_VENTA_FAILED',

  SET_BULTOS_TO_VENTA_REDUCER: 'SET_BULTOS_TO_VENTA_REDUCER',

  VENTAS_RELOAD_VENTA_REQUESTED: 'VENTAS_RELOAD_VENTA_REQUESTED',
  VENTAS_RELOAD_VENTA_SUCCEEDED: 'VENTAS_RELOAD_VENTA_SUCCEEDED',
  VENTAS_RELOAD_VENTA_FILED: 'VENTAS_RELOAD_VENTA_FILED',

  SET_ESTADO_VENTA_MASIVO_REQUESTED: 'SET_ESTADO_VENTA_MASIVO_REQUESTED',
  SET_ESTADO_VENTA_MASIVO_SUCCEEDED: 'SET_ESTADO_VENTA_MASIVO_SUCCEEDED',
  SET_ESTADO_VENTA_MASIVO_FAILED: 'SET_ESTADO_VENTA_MASIVO_FAILED',

  SET_ESTADO_MENSAJERIA_VENTA_MASIVO_REQUESTED: 'SET_ESTADO_MENSAJERIA_VENTA_MASIVO_REQUESTED',
  SET_ESTADO_MENSAJERIA_VENTA_MASIVO_SUCCEEDED: 'SET_ESTADO_MENSAJERIA_VENTA_MASIVO_SUCCEEDED',
  SET_ESTADO_MENSAJERIA_VENTA_MASIVO_FAILED: 'SET_ESTADO_MENSAJERIA_VENTA_MASIVO_FAILED',

  SET_DIRECCION_MAPA_VENTA_REQUESTED: 'SET_DIRECCION_MAPA_VENTA_REQUESTED',
  SET_DIRECCION_MAPA_VENTA_SUCCEEDED: 'SET_DIRECCION_MAPA_VENTA_SUCCEEDED',
  SET_DIRECCION_MAPA_VENTA_FAILED: 'SET_DIRECCION_MAPA_VENTA_FAILED',

  GET_PEDIDOS_MENSAJERO_VENTA_REQUESTED: 'GET_PEDIDOS_MENSAJERO_VENTA_REQUESTED',
  GET_PEDIDOS_MENSAJERO_VENTA_SUCCEEDED: 'GET_PEDIDOS_MENSAJERO_VENTA_SUCCEEDED',
  GET_PEDIDOS_MENSAJERO_VENTA_FAILED: 'GET_PEDIDOS_MENSAJERO_VENTA_FAILED',

  GET_PEDIDOS_SIN_MENSAJERO_VENTA_REQUESTED: 'GET_PEDIDOS_SIN_MENSAJERO_VENTA_REQUESTED',
  GET_PEDIDOS_SIN_MENSAJERO_VENTA_SUCCEEDED: 'GET_PEDIDOS_SIN_MENSAJERO_VENTA_SUCCEEDED',
  GET_PEDIDOS_SIN_MENSAJERO_VENTA_FAILED: 'GET_PEDIDOS_SIN_MENSAJERO_VENTA_FAILED',

  SET_ORDEN_PEDIDOS_MENSAJERO_REQUESTED: 'SET_ORDEN_PEDIDOS_MENSAJERO_REQUESTED',
  SET_ORDEN_PEDIDOS_MENSAJERO_SUCCEEDED: 'SET_ORDEN_PEDIDOS_MENSAJERO_SUCCEEDED',
  SET_ORDEN_PEDIDOS_MENSAJERO_FAILED: 'SET_ORDEN_PEDIDOS_MENSAJERO_FAILED',

  SET_DATOS_ENTREGA_VENTA_REQUESTED: 'SET_DATOS_ENTREGA_VENTA_REQUESTED',
  SET_DATOS_ENTREGA_VENTA_SUCCEEDED: 'SET_DATOS_ENTREGA_VENTA_SUCCEEDED',
  SET_DATOS_ENTREGA_VENTA_FAILED: 'SET_DATOS_ENTREGA_VENTA_FAILED',

  SET_TRANSPORTISTA_VENTA_REQUESTED: 'SET_TRANSPORTISTA_VENTA_REQUESTED',
  SET_TRANSPORTISTA_VENTA_SUCCEEDED: 'SET_TRANSPORTISTA_VENTA_SUCCEEDED',
  SET_TRANSPORTISTA_VENTA_FAILED: 'SET_TRANSPORTISTA_VENTA_FAILED',

  DELETE_TRANSPORTISTA_VENTA_REQUESTED: 'DELETE_TRANSPORTISTA_VENTA_REQUESTED',
  DELETE_TRANSPORTISTA_VENTA_SUCCEEDED: 'DELETE_TRANSPORTISTA_VENTA_SUCCEEDED',
  DELETE_TRANSPORTISTA_VENTA_FAILED: 'DELETE_TRANSPORTISTA_VENTA_FAILED',

  SET_VENTAITEM_QUANTITY_SUCEEDED: 'SET_VENTAITEM_QUANTITY_SUCEEDED',
  SET_VENTAITEMS_PRECIO_SUCEEDED: 'SET_VENTAITEMS_PRECIO_SUCEEDED',

  SET_VENTA_MENSAJERO_SEPARADO_REQUESTED: 'SET_VENTA_MENSAJERO_SEPARADO_REQUESTED',
  SET_VENTA_MENSAJERO_SEPARADO_SUCCEEDED: 'SET_VENTA_MENSAJERO_SEPARADO_SUCCEEDED',
  SET_VENTA_MENSAJERO_SEPARADO_FAILED: 'SET_VENTA_MENSAJERO_SEPARADO_FAILED',

  INPOST_PUP_ID_UPDATED: 'INPOST_PUP_ID_UPDATED',
  VENTA_ALBARAN_UPDATED: 'VENTA_ALBARAN_UPDATED',

  AMAZON_FILTER_REQUESTED: 'AMAZON_FILTER_REQUESTED',
  AMAZON_FILTER_SUCCEEDED: 'AMAZON_FILTER_SUCCEEDED',
  AMAZON_FILTER_FAILED: 'AMAZON_FILTER_FAILED',

  AMAZON_TRANSMITIR_REQUESTED: 'AMAZON_TRANSMITIR_REQUESTED',
  AMAZON_TRANSMITIR_SUCCEEDED: 'AMAZON_TRANSMITIR_SUCCEEDED',
  AMAZON_TRANSMITIR_FAILED: 'AMAZON_TRANSMITIR_FAILED',

  SET_ESTANTERIA_PRESELECCIONADA_REQUESTED: 'SET_ESTANTERIA_PRESELECCIONADA_REQUESTED',
  SET_ESTANTERIA_PRESELECCIONADA_SUCCEEDED: 'SET_ESTANTERIA_PRESELECCIONADA_SUCCEEDED',
  SET_ESTANTERIA_PRESELECCIONADA_FAILED: 'SET_ESTANTERIA_PRESELECCIONADA_FAILED',

  VENTAS_TILDAR_FILTER_LOAD_REQUESTED: 'VENTAS_TILDAR_FILTER_LOAD_REQUESTED',
  VENTAS_TILDAR_FILTER_LOAD_SUCCEEDED: 'VENTAS_TILDAR_FILTER_LOAD_SUCCEEDED',
  VENTAS_TILDAR_FILTER_LOAD_FILED: 'VENTAS_TILDAR_FILTER_LOAD_FILED',
}

export const getVentasAction = dispatch => {
  dispatch({
    type: actions.VENTAS_LOAD_REQUESTED,
  })
}

export const reloadVentaInVentasAction = (dispatch, id) => {
  dispatch({
    type: actions.VENTAS_RELOAD_VENTA_REQUESTED,
    id,
  })
}

export const resetVentaAction = dispatch => {
  dispatch({
    type: actions.RESET_VENTA_LOAD_REQUESTED,
  })
}

export const addVentasListAction = (dispatch, ventas) => {
  dispatch({
    type: actions.ADD_VENTA_LOAD_REQUESTED,
    ventas,
  })
}

export const onSubmitUpdateVentaFormAction = (dispatch, formVenta) => {
  dispatch({
    type: actions.VENTA_UPDATE_REQUESTED,
    payload: formVenta,
  })
}

export const clearVentasAction = dispatch => {
  dispatch({ type: actions.VENTAS_CLEAR })
}

export const getVentasFilterAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterMensajerosNuestrosAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_MENSAJEROS_NUESTROS_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterGrabadosSinPersoAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_GRABADOS_SIN_PERSO_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterBordadosSinPersoAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_BORDADOS_SIN_PERSO_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterRescateAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_RESCATE_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterPersonalizadosAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_PERSONALIZADOS_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterPersonalizadosTotalAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_PERSONALIZADOS_TOTAL_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterPersonalizadosPreparadosAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_PERSONALIZADOS_PREPARADOS_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterPersonalizadosFabricadosAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_PERSONALIZADOS_FABRICADOS_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterEnSobreAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_EN_SOBRE_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterTodosAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_TODOS_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterNocturnosAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_NOCTURNOS_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterNuestrosNocturnosAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_NUESTROS_NOCTURNO_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterNocturnosCorreosAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_NOCTURNOS_CORREOS_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterDiurnosAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_DIURNOS_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterFigurasLegoAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_FIGURAS_LEGO_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterEcommerceAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_ECOMMERCE_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterEcommerceTramoHorarioAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_ECOMMERCE_TRAMO_HORARIO_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterLocalAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_LOCAL_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterDigitalAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_DIGITAL_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterEmpleadosAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_EMPLEADOS_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterEkomiAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_EKOMI_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterAmazonAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_AMAZON_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterFueraDeEspanaAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_FUERA_DE_ESPANA_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterFueraDeEspanaSeurAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_FUERA_DE_ESPANA_SEUR_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterFueraDeEspanaDhlAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_FUERA_DE_ESPANA_DHL_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterDhlAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_DHL_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentasFilterChocomensajeMasivoAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_FILTER_CHOCOMENSAJE_MASIVO_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getVentaByIdAction = (dispatch, id, background = false) => {
  if (!id) return
  dispatch({
    type: actions.VENTA_BYID_LOAD_REQUESTED,
    payload: id,
    background,
  })
}

export const getObservacionesVenta = dispatch => {
  dispatch({
    type: actions.OBSERVACIONES_VENTA_LOAD_REQUESTED,
  })
}

export const getMailObservacionTemplateVenta = (dispatch) => {
  dispatch({
    type: actions.MAIL_OBSERVACION_TEMPLATE_VENTA_LOAD_REQUESTED,
  })
}

export const deleteMailObservacionAction = (dispatch, id) => {
  dispatch({
    type: actions.DELETE_MAIL_OBSERVACION_TEMPLATE_REQUESTED,
    payload: id,
  })
}

export const onSubmitInsertMailObservacionFormAction = (dispatch, mailTemplateForm) => {
  dispatch({
    type: actions.MAIL_OBSERVACION_TEMPLATE_INSERT_REQUESTED,
    payload: mailTemplateForm,
  })
}

export const onSubmitUpdateMailObservacionFormAction = (dispatch, mailTemplateForm) => {
  dispatch({
    type: actions.MAIL_OBSERVACION_TEMPLATE_UPDATE_REQUESTED,
    payload: mailTemplateForm,
  })
}

export const onSubmitInsertObservacionSeguimientoVentaFormAction = (
  dispatch,
  formObservacionSeguimientoVenta,
) => {
  dispatch({
    type: actions.OBSERVACION_SEGUIMIENTO_VENTA_INSERT_REQUESTED,
    payload: formObservacionSeguimientoVenta,
  })
}

export const observacionSeguimientoVentaInsertedAction = (dispatch, payload) => {
  dispatch({
    type: actions.OBSERVACION_SEGUIMIENTO_VENTA_INSERT_SUCCEEDED,
    payload,
  })
}

export const onSubmitInsertObservacionesPreparacionEmergenteFormAction = (
  dispatch,
  formObservacionSeguimientoVenta,
) => {
  dispatch({
    type: actions.OBSERVACION_SEGUIMIENTO_PREPARACION_EMERGENTE_VENTA_INSERT_REQUESTED,
    payload: formObservacionSeguimientoVenta,
  })
}

export const observacionPreparacionVentaInsertedAction = (dispatch, payload) => {
  dispatch({
    type: actions.OBSERVACION_SEGUIMIENTO_PREPARACION_EMERGENTE_VENTA_INSERT_SUCCEEDED,
    payload,
  })
}

export const setObservacionesBultoAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_OBSERVACIONES_BULTO_REQUESTED,
    payload,
  })
}

export const setBultosCheckAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_BULTOS_CHECK_REQUESTED,
    payload,
  })
}

export const onDeleteAbonoAction = (dispatch, id) => {
  dispatch({
    type: actions.ABONO_DELETE_REQUESTED,
    payload: id,
  })
}

export const onDeleteCuponAction = (dispatch, cuponUsadoForm) => {
  dispatch({
    type: actions.CUPON_DELETE_REQUESTED,
    payload: cuponUsadoForm,
  })
}

export const getCuponesAction = dispatch => {
  dispatch({
    type: actions.CUPONES_LOAD_REQUESTED,
  })
}

export const onAddCuponesAction = (dispatch, cuponesUsadosForm) => {
  dispatch({
    type: actions.ADD_CUPONES_REQUESTED,
    payload: cuponesUsadosForm,
  })
}

export const onCancelarVentaAction = (dispatch, cancelarVentaForm) => {
  dispatch({
    type: actions.CANCELAR_VENTA_REQUESTED,
    payload: cancelarVentaForm,
  })
}

export const onEnviarMailObservacionVentaAction = (dispatch, mailObservacionVentaForm) => {
  dispatch({
    type: actions.ENVIAR_MAIL_OBSERVACION_VENTA_REQUESTED,
    payload: mailObservacionVentaForm,
  })
}

export const onEnviarMailObservacionVentaDoneAction = (dispatch, mailObservacionVentaForm) => {
  dispatch({
    type: actions.ENVIAR_MAIL_OBSERVACION_VENTA_DONE_REQUESTED,
    payload: mailObservacionVentaForm,
  })
}

export const onBorrarMensajeroAction = (dispatch, borrarMensajeroForm) => {
  dispatch({
    type: actions.BORRAR_MENSAJERO_REQUESTED,
    payload: borrarMensajeroForm,
  })
}

export const onBorrarBandejaAction = (dispatch, borrarBandejaForm) => {
  dispatch({
    type: actions.BORRAR_BANDEJA_REQUESTED,
    payload: borrarBandejaForm,
  })
}

export const onMarcarPagadoAction = (dispatch, marcarPagadoForm) => {
  dispatch({
    type: actions.MARCAR_PAGADO_REQUESTED,
    payload: marcarPagadoForm,
  })
}

// Refleja en la venta cargada el numero de factura asignado al imprimir la factura (sin recargar la venta,
// para no pisar lo que el usuario tenga editado en el formulario). Incluye el timestamp nuevo.
export const asignarNumeroFacturaSucceededAction = (dispatch, payload) => {
  dispatch({
    type: actions.ASIGNAR_NUMERO_FACTURA_SUCCEEDED,
    payload,
  })
}

export const insertNuevaDevolucionAction = (dispatch, nuevaDevolucionForm) => {
  dispatch({
    type: actions.INSERTAR_NUEVA_DEVOLUCION_REQUESTED,
    payload: nuevaDevolucionForm,
  })
}

export const aularDevolucionAction = (dispatch, anularDevolucionForm) => {
  dispatch({
    type: actions.ANULAR_DEVOLUCION_REQUESTED,
    payload: anularDevolucionForm,
  })
}

export const setVentaLetraAction = (dispatch, setVentaLetraForm) => {
  dispatch({
    type: actions.SET_VENTA_LETRA_REQUESTED,
    payload: setVentaLetraForm,
  })
}

export const setVipAction = (dispatch, setVentaVipForm) => {
  dispatch({
    type: actions.SET_VENTA_VIP_REQUESTED,
    payload: setVentaVipForm,
  })
}

export const insertNuevoAbonoAction = (dispatch, nuevoAbonoForm) => {
  dispatch({
    type: actions.INSERT_ABONO_REQUESTED,
    payload: nuevoAbonoForm,
  })
}

export const traspasarVentaAction = (dispatch, traspasarVentaForm) => {
  dispatch({
    type: actions.TRASPASAR_VENTA_REQUESTED,
    payload: traspasarVentaForm,
  })
}

export const setVentaItemFaltanteAction = (dispatch, faltanteInfo) => {
  dispatch({
    type: actions.SET_VENTA_ITEM_FALTANTE,
    payload: faltanteInfo,
  })
}

export const getDhlBuscar = (dispatch, dhlBuscarForm) => {
  dispatch({
    type: actions.DHL_BUSCAR_REQUESTED,
    payload: dhlBuscarForm,
  })
}

export const getDhl = (dispatch, dhlBuscarForm) => {
  dispatch({
    type: actions.DHL_DHL_BUSCAR_REQUESTED,
    payload: dhlBuscarForm,
  })
}

export const getMrwClickBuscar = (dispatch, mrwClickBuscarForm) => {
  dispatch({
    type: actions.MRWCLICK_BUSCAR_REQUESTED,
    payload: mrwClickBuscarForm,
  })
}

export const getMrwClickDiurnos = (dispatch, mrwClickBuscarForm) => {
  dispatch({
    type: actions.MRWCLICK_DIURNOS_REQUESTED,
    payload: mrwClickBuscarForm,
  })
}

export const getMrwClickNocturnos = (dispatch, mrwClickBuscarForm) => {
  dispatch({
    type: actions.MRWCLICK_NOCTURNOS_REQUESTED,
    payload: mrwClickBuscarForm,
  })
}

export const getMrwClickEcommerce = (dispatch, mrwClickBuscarForm) => {
  dispatch({
    type: actions.MRWCLICK_ECOMMERCE_REQUESTED,
    payload: mrwClickBuscarForm,
  })
}

export const getMrwClickEcommerceTh = (dispatch, mrwClickBuscarForm) => {
  dispatch({
    type: actions.MRWCLICK_ECOMMERCETH_REQUESTED,
    payload: mrwClickBuscarForm,
  })
}

export const getMrwClickSobre = (dispatch, mrwClickBuscarForm) => {
  dispatch({
    type: actions.MRWCLICK_SOBRE_REQUESTED,
    payload: mrwClickBuscarForm,
  })
}

export const cambiarEstadosMensajeriaAction = (dispatch, cambioEstadoForm) => {
  dispatch({
    type: actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_REQUESTED,
    payload: cambioEstadoForm,
  })
}

export const cambiarEstadosMensajeriaSeurAction = (dispatch, cambioEstadoForm) => {
  dispatch({
    type: actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_SEUR_REQUESTED,
    payload: cambioEstadoForm,
  })
}

export const cambiarEstadosMensajeriaCorreosExpressAction = (dispatch, cambioEstadoForm) => {
  dispatch({
    type: actions.VENTA_CAMBIAR_ESTADO_MENSAJERIA_CORREOS_EXPRESS_REQUESTED,
    payload: cambioEstadoForm,
  })
}

export const updateDhlbjetosAction = (dispatch, objetosDhl) => {
  dispatch({
    type: actions.UPDATE_DHL_OBJETOS,
    payload: objetosDhl,
  })
}

export const updateMrwClickObjetosAction = (dispatch, objetosMrwsClick) => {
  dispatch({
    type: actions.UPDATE_MRWCLICK_OBJETOS,
    payload: objetosMrwsClick,
  })
}

export const updateMrwsClickAction = (
  dispatch,
  mrwsClick,
  tipo,
  fechaRecogidaId,
  fechaRecogida,
  tipoTransmisionId,
) => {
  dispatch({
    type: actions.MRWCLICK_UPDATE_REQUESTED,
    payload: { mrwsList: mrwsClick, tipo, fechaRecogidaId, fechaRecogida, tipoTransmisionId },
  })
}

export const transmitirMrwsAction = (dispatch, ventasIds) => {
  dispatch({
    type: actions.MRWCLICK_TRANSMITIR_REQUESTED,
    payload: ventasIds,
  })
}

export const updateDhlsAction = (dispatch, dhls) => {
  dispatch({
    type: actions.DHLS_UPDATE_REQUESTED,
    payload: dhls,
  })
}

export const transmitirDhlsAction = (dispatch, ventasIds) => {
  dispatch({
    type: actions.DHLS_TRANSMITIR_REQUESTED,
    payload: ventasIds,
  })
}

export const getSeurBuscar = (dispatch, seurBuscarForm) => {
  dispatch({
    type: actions.SEUR_BUSCAR_REQUESTED,
    payload: seurBuscarForm,
  })
}

export const getSeur = (dispatch, seurBuscarForm) => {
  dispatch({
    type: actions.SEUR_SEUR_BUSCAR_REQUESTED,
    payload: seurBuscarForm,
  })
}

export const updateSeurbjetosAction = (dispatch, objetosSeur) => {
  dispatch({
    type: actions.UPDATE_SEUR_OBJETOS,
    payload: objetosSeur,
  })
}

export const updateCorreosExpressObjetosAction = (dispatch, objetosCorreosExpress) => {
  dispatch({
    type: actions.UPDATE_CORREOS_EXPRESS_OBJETOS,
    payload: objetosCorreosExpress,
  })
}

export const updateSeursAction = (dispatch, seurs) => {
  dispatch({
    type: actions.SEURS_UPDATE_REQUESTED,
    payload: seurs,
  })
}

export const updateCorreosExpressAction = (dispatch, correosExpress) => {
  dispatch({
    type: actions.CORREOS_EXPRESS_UPDATE_REQUESTED,
    payload: correosExpress,
  })
}

export const transmitirSeursAction = (dispatch, ventasIds) => {
  dispatch({
    type: actions.SEURS_TRANSMITIR_REQUESTED,
    payload: ventasIds,
  })
}

export const transmitirCorreosExpressAction = (dispatch, ventasIds) => {
  dispatch({
    type: actions.CORREOS_EXPRESS_TRANSMITIR_REQUESTED,
    payload: ventasIds,
  })
}

export const setDisenoSvgVentaItemDescargadoAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_DISENO_SVG_VENTA_ITEM_DESCARGADO,
    payload,
  })
}

export const deleteImagenFinalDisenoSvgAction = (dispatch, payload) => {
  dispatch({
    type: actions.DELETE_IMAGEN_FINAL_DISENO_SVG,
    payload,
  })
}

export const addLogVentaItemPersonalizadoAction = (dispatch, payload) => {
  dispatch({
    type: actions.ADD_LOG_VENTA_ITEM_PERSONALIZADO,
    payload,
  })
}

export const addLogVentaItemSeparadoAction = (dispatch, payload) => {
  dispatch({
    type: actions.ADD_LOG_VENTA_ITEM_SEPARADO_REQUESTED,
    payload,
  })
}

export const addLogVentaItemVerificadoAction = (dispatch, payload) => {
  dispatch({
    type: actions.ADD_ITEM_VENTA_VERIFICADO_REQUESTED,
    payload,
  })
}

export const addLogVentaItemSeparadoSucceededAction = (dispatch, payload) => {
  dispatch({
    type: actions.ADD_LOG_VENTA_ITEM_SEPARADO_SUCCEEDED,
    payload,
  })
}

export const addLogVentaItemVerificadoSucceededAction = (dispatch, payload) => {
  dispatch({
    type: actions.ADD_ITEM_VENTA_VERIFICADO_SUCCEEDED,
    payload,
  })
}

export const setVentaItemImprimirAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_VENTA_ITEM_IMPRIMIR,
    payload,
  })
}

export const deleteVentaItemsAction = (dispatch, payload) => {
  dispatch({
    type: actions.DELETE_VENTA_ITEMS,
    payload,
  })
}

export const ventaItemMarcarEliminarAction = (dispatch, payload) => {
  dispatch({
    type: actions.VENTA_ITEM_MARCAR_ELIMINAR,
    payload,
  })
}

export const ventaItemDesmarcarEliminarAction = (dispatch, payload) => {
  dispatch({
    type: actions.VENTA_ITEM_DESMARCAR_ELIMINAR,
    payload,
  })
}

export const ventaItemIlustracionInsertedAction = (dispatch, payload) => {
  dispatch({
    type: actions.VENTA_ITEM_ILUSTRACION_INSERTED,
    payload,
  })
}

export const ventaItemIlustracionDeletedAction = (dispatch, payload) => {
  dispatch({
    type: actions.VENTA_ITEM_ILUSTRACION_DELETED,
    payload,
  })
}

export const getCorreosExpressBuscar = (dispatch, correosExpressBuscarForm) => {
  dispatch({
    type: actions.CORREOS_EXPRESS_BUSCAR_REQUESTED,
    payload: correosExpressBuscarForm,
  })
}

export const getCorreosExpressEcommerce = (dispatch, correosExpressBuscarForm) => {
  dispatch({
    type: actions.CORREOS_EXPRESS_ECOMMERCE_REQUESTED,
    payload: correosExpressBuscarForm,
  })
}

export const getCorreosExpressEcommerceTramo = (dispatch, correosExpressBuscarForm) => {
  dispatch({
    type: actions.CORREOS_EXPRESS_ECOMMERCE_TRAMO_REQUESTED,
    payload: correosExpressBuscarForm,
  })
}

export const getCorreosExpressSobres = (dispatch, correosExpressBuscarForm) => {
  dispatch({
    type: actions.CORREOS_EXPRESS_SOBRES_REQUESTED,
    payload: correosExpressBuscarForm,
  })
}
export const addLogMailVentaAction = (dispatch, payload) => {
  dispatch({
    type: actions.ADD_LOG_MAIL_VENTA,
    payload,
  })
}

export const ventaItemImagenesIncidenciaInsertedAction = (dispatch, payload) => {
  dispatch({
    type: actions.VENTA_ITEM_IMAGENES_INCIDENCIA_INSERTED,
    payload,
  })
}

export const ventaItemImagenIncidenciaDeletedAction = (dispatch, payload) => {
  dispatch({
    type: actions.VENTA_ITEM_IMAGEN_INCIDENCIA_DELETED,
    payload,
  })
}

export const ventaItemAmazonZipInsertedAction = (dispatch, payload) => {
  dispatch({
    type: actions.VENTA_ITEM_AMAZON_ZIP_INSERTED,
    payload,
  })
}

export const ventaObservacionPersonalizacionInsertedAction = (dispatch, payload) => {
  dispatch({
    type: actions.VENTA_OBSERVACION_PERSONALIZACION_VENTA_INSERTED,
    payload,
  })
}

export const onSubmitInsertObservacionesFormAction = (dispatch, formObservacion) => {
  dispatch({
    type: actions.OBSERVACION_INSERT_REQUESTED,
    payload: formObservacion,
  })
}

export const onSubmitModificarObservacionFormAction = (dispatch, formObservacion) => {
  dispatch({
    type: actions.OBSERVACION_UPDATE_REQUESTED,
    payload: formObservacion,
  })
}

export const deleteObservacionAction = (dispatch, observacionId) => {
  dispatch({
    type: actions.OBSERVACION_DELETE_REQUESTED,
    payload: observacionId,
  })
}

export const onSubmitInsertEstadosBultosFormAction = (dispatch, formEstadosBultos) => {
  dispatch({
    type: actions.ESTADOS_BULTOS_INSERT_REQUESTED,
    payload: formEstadosBultos,
  })
}

export const onSubmitModificarEstadosBultosFormAction = (dispatch, formEstadosBultos) => {
  dispatch({
    type: actions.ESTADOS_BULTOS_UPDATE_REQUESTED,
    payload: formEstadosBultos,
  })
}

export const deleteEstadosBultosAction = (dispatch, estadoBultoId) => {
  dispatch({
    type: actions.ESTADOS_BULTOS_DELETE_REQUESTED,
    payload: estadoBultoId,
  })
}

export const getEstadosBultosAction = dispatch => {
  dispatch({
    type: actions.ESTADOS_BULTOS_LOAD_REQUESTED,
  })
}

export const getTodasBandejasAction = dispatch => {
  dispatch({
    type: actions.TODAS_BANDEJAS_LOAD_REQUESTED,
  })
}

export const getBandejaByIdAction = (dispatch, id) => {
  dispatch({
    type: actions.BANDEJA_LOAD_REQUESTED,
    payload: { id },
  })
}

export const vaciarTodasBandejastion = (dispatch, bandejaId) => {
  dispatch({
    type: actions.TODAS_BANDEJAS_VACIAR_REQUESTED,
    payload: bandejaId,
  })
}

export const getBandejasAction = dispatch => {
  dispatch({
    type: actions.BANDEJAS_LOAD_REQUESTED,
  })
}

export const getBandejasLogAction = dispatch => {
  dispatch({
    type: actions.BANDEJAS_LOG_LOAD_REQUESTED,
  })
}

export const terminarBandejaAction = (dispatch, payload) => {
  dispatch({
    type: actions.BANDEJA_TERMINAR_REQUESTED,
    payload,
  })
}

export const getEstanteriasAction = dispatch => {
  dispatch({
    type: actions.ESTANTERIAS_LOAD_REQUESTED,
  })
}

export const onSubmitInsertEstanteriaFormAction = (dispatch, formEstanteria) => {
  dispatch({
    type: actions.ESTANTERIA_INSERT_REQUESTED,
    payload: formEstanteria,
  })
}

export const onSubmitModificarEstanteriaFormAction = (dispatch, formEstanteria) => {
  dispatch({
    type: actions.ESTANTERIA_UPDATE_REQUESTED,
    payload: formEstanteria,
  })
}

export const onSubmitBandejaTerminadaFormAction = (dispatch, formEstanteria) => {
  dispatch({
    type: actions.BANDEJA_TERMINADA_REQUESTED,
    payload: formEstanteria,
  })
}

export const onDeleteEstanteriaFormAction = (dispatch, id) => {
  dispatch({
    type: actions.ESTANTERIA_DELETE_REQUESTED,
    payload: id,
  })
}

export const getEstantesLlenosAction = dispatch => {
  dispatch({
    type: actions.ESTANTES_LLENOS_LOAD_REQUESTED,
  })
}

export const getCodigoBarrasEstanteriaAction = dispatch => {
  dispatch({
    type: actions.CODIGO_BARRAS_ESTANTERIA_LOAD_REQUESTED,
  })
}

export const getEstanteVentaAction = (dispatch, id) => {
  dispatch({
    type: actions.ESTANTE_VENTA_LOAD_REQUESTED,
    payload: id,
  })
}

export const setVentaBandejaAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_VENTA_BANDEJA_REQUESTED,
    payload,
  })
}

export const deleteVentaBandejaAction = (dispatch, id) => {
  dispatch({
    type: actions.DELETE_VENTA_BANDEJA_REQUESTED,
    id,
  })
}

export const removeVentaBandejaAction = (dispatch, payload) => {
  dispatch({
    type: actions.REMOVE_VENTA_BANDEJA_REQUESTED,
    payload,
  })
}

export const removeVentaEstanteAction = (dispatch, payload) => {
  dispatch({
    type: actions.REMOVE_VENTA_ESTANTE_REQUESTED,
    payload,
  })
}

export const removeAllVentaBandejaAction = (dispatch, id) => {
  dispatch({
    type: actions.REMOVE_ALL_VENTA_BANDEJA_REQUESTED,
    id,
  })
}

export const vaciarBandejaAction = (dispatch, id) => {
  dispatch({
    type: actions.BANDEJA_VACIAR_REQUESTED,
    payload: id,
  })
}

export const getCorreosExpressAction = (dispatch, payload) => {
  dispatch({
    type: actions.CORREOS_EXPRESS_LOAD_REQUESTED,
    payload,
  })
}

export const setItemVentaPersonalizadoAction = (dispatch, payload) => {
  dispatch({
    type: actions.ADD_ITEM_VENTA_PERSONALIZADO_REQUESTED,
    payload,
  })
}

export const setVentaFinalizarImprimirAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_VENTA_FINALIZAR_IMPRIMIR_REQUESTED,
    payload,
  })
}

// Aplica el patch de campos (optimista o de reconciliación tras el PUT) sin pasar
// por el saga — usado por ImprimirSinGuardar, que llama al servicio directamente.
export const patchVentaFinalizarImprimirAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_VENTA_FINALIZAR_IMPRIMIR_SUCCEEDED,
    payload,
  })
}

export const getOrdenEstanteriaAction = (dispatch, usuarioId) => {
  dispatch({
    type: actions.GET_ORDEN_ESTANTERIA_REQUESTED,
    usuarioId,
  })
}

export const setOrdenEstanteriaAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_ORDEN_ESTANTERIA_REQUESTED,
    payload,
  })
}

export const getEstanteAleatorioAction = (dispatch, usuarioId) => {
  dispatch({
    type: actions.GET_ESTANTE_ALEATORIO_REQUESTED,
    usuarioId,
  })
}

export const setVentaEstanteriaAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_VENTA_ESTANTERIA_UPDATE_REQUESTED,
    payload,
  })
}

export const setObservacionCierreVentaAction = (dispatch, observacionCierreVenta) => {
  dispatch({
    type: actions.OBSERVACION_CIERRE_VENTA_INSERT_REQUESTED,
    payload: observacionCierreVenta,
  })
}

export const setItemVentaVerificadoAction = (dispatch, payload) => {
  dispatch({
    type: actions.ADD_ITEM_VENTA_VERIFICADO_REQUESTED,
    payload,
  })
}

export const getVentasAgrupadasAction = (dispatch, ventaId) => {
  dispatch({
    type: actions.GET_VENTAS_AGRUPADAS_REQUESTED,
    ventaId,
  })
}

export const setBandejaPropuestaAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_BANDEJA_PROPUESTA_LOAD_REQUESTED,
    payload,
  })
}

export const getModificacionesVentaAction = (dispatch, payload) => {
  dispatch({
    type: actions.GET_MODIFICACIONES_VENTA_REQUESTED,
    payload,
  })
}

export const setEstadoVentaAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_ESTADO_VENTA_REQUESTED,
    payload,
  })
}

export const setEstadoBultoVentaAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_ESTADO_BULTO_VENTA_REQUESTED,
    payload,
  })
}

export const setObservacionesBultoListaAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_OBSERVACIONES_BULTO_LISTA_REQUESTED,
    payload,
  })
}

export const setBultoToVentaReducerAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_BULTOS_TO_VENTA_REDUCER,
    payload,
  })
}

export const setEstadoVentaMasivoAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_ESTADO_VENTA_MASIVO_REQUESTED,
    payload,
  })
}

export const setEstadoMensajeriaVentaMasivoAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_ESTADO_MENSAJERIA_VENTA_MASIVO_REQUESTED,
    payload,
  })
}

export const getPedidosMensajeroAction = (dispatch, payload) => {
  dispatch({
    type: actions.GET_PEDIDOS_MENSAJERO_VENTA_REQUESTED,
    payload,
  })
}

export const getPedidosSinMensajeroAction = (dispatch, payload) => {
  dispatch({
    type: actions.GET_PEDIDOS_SIN_MENSAJERO_VENTA_REQUESTED,
    payload,
  })
}

export const setOrdenPedidosMensajeroAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_ORDEN_PEDIDOS_MENSAJERO_REQUESTED,
    payload,
  })
}

// alTerminar(ok) se llama cuando la saga acaba, con true si se guardó y false si falló
export const setDatosEntregaVentaAction = (dispatch, payload, alTerminar) => {
  dispatch({
    type: actions.SET_DATOS_ENTREGA_VENTA_REQUESTED,
    payload,
    alTerminar,
  })
}

export const setTransportistaVentaAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_TRANSPORTISTA_VENTA_REQUESTED,
    payload,
  })
}

// Aplica en el store el orden de las paradas ya movidas; el guardado en el servidor lo hace el componente
export const setOrdenPedidosMensajeroAplicadoAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_ORDEN_PEDIDOS_MENSAJERO_SUCCEEDED,
    payload,
  })
}

export const deleteTransportistaVentaAction = (dispatch, payload) => {
  dispatch({
    type: actions.DELETE_TRANSPORTISTA_VENTA_REQUESTED,
    payload,
  })
}

export const setVentaItemQuantityCompletedAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_VENTAITEM_QUANTITY_SUCEEDED,
    payload,
  })
}

export const setVentaItemsPrecioCompletedAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_VENTAITEMS_PRECIO_SUCEEDED,
    payload,
  })
}

export const setMensajeroSeparadoAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_VENTA_MENSAJERO_SEPARADO_REQUESTED,
    payload,
  })
}

export const inpostPupIdUpdatedAction = (dispatch, payload) => {
  dispatch({
    type: actions.INPOST_PUP_ID_UPDATED,
    payload,
  })
}
export const ventaAlbaranUpdatedAction = (dispatch, payload) => {
  dispatch({
    type: actions.VENTA_ALBARAN_UPDATED,
    payload,
  })
}

export const getAmazonFilterAction = (dispatch, filter) => {
  dispatch({
    type: actions.AMAZON_FILTER_REQUESTED,
    payload: filter,
  })
}

export const setAmazonTransmitirAction = (dispatch, pedidos) => {
  dispatch({
    type: actions.AMAZON_TRANSMITIR_REQUESTED,
    payload: pedidos,
  })
}

export const getVentaByIdControlDisenoAction = (dispatch, id, background = false) => {
  if (!id) return
  dispatch({
    type: actions.VENTA_BYID_CONTROLDISENO_LOAD_REQUESTED,
    payload: id,
    background,
  })
}

export const setEstanteriaPreseleccionadaAction = (dispatch, payload) => {
  dispatch({
    type: actions.SET_ESTANTERIA_PRESELECCIONADA_REQUESTED,
    payload,
  })
}

export const getVentasTildarFilterAction = (dispatch, filter) => {
  dispatch({
    type: actions.VENTAS_TILDAR_FILTER_LOAD_REQUESTED,
    payload: filter,
  })
}
